import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useIntl } from 'react-intl';
import { Button } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { showReleaseRescueButton, showUnClaimRescueButtons } from '../../helpers/RescuesHelper';
import useRescuerRescueActions from '../../hooks/useRescuerRescueActions';
import ConfirmationDialog from '../ConfirmationDialog';
import useActiveUser from '../../hooks/useActiveUser';

const ReleaseRescueConfirmationDialog = ({ buttons, onClose, title, message }) => (
  <ConfirmationDialog buttons={buttons} closeDialog={onClose} title={title} message={message} />
);

const ReleaseRescueButtons = ({ rescue, buttonVariant = 'contained' }) => {
  const { releaseRescue, rescueUnclaim } = useRescuerRescueActions();
  const rescuer = useActiveUser();
  const { formatMessage } = useIntl();

  const handleOnUnClaimClick = () =>
    confirmAlert({
      title: 'Are you sure?',
      buttons: [
        {
          variant: 'outlined',
          label: 'Never Mind',
          color: 'primary',
          onClick: () => {},
        },
        {
          variant: 'contained',
          label: 'Release',
          color: 'primary',
          onClick: () => rescueUnclaim(rescue, true),
        },
      ],
      message: 'Releasing this rescue may result in this food going to waste, but we understand that life happens!',
      customUI: ReleaseRescueConfirmationDialog,
    });

  const handleReleaseClick = () =>
    confirmAlert({
      title: 'Are you sure?',
      buttons: [
        {
          variant: 'outlined',
          label: 'Never Mind',
          color: 'primary',
          onClick: () => {},
        },
        {
          variant: 'contained',
          label: 'Release',
          color: 'primary',
          onClick: () => releaseRescue(rescue, true),
        },
      ],
      message: 'Releasing this rescue may result in this food going to waste, but we understand that life happens!',
      customUI: ReleaseRescueConfirmationDialog,
    });

  return (
    <>
      {showUnClaimRescueButtons(rescue, rescuer) && (
        <Button
          fullWidth
          startIcon={<CloseIcon />}
          size="large"
          color="primary"
          variant="contained"
          onClick={handleOnUnClaimClick}
        >
          {formatMessage({ id: 'rescuer-dashboard-mobile.buttons.release-rescue' })}
        </Button>
      )}

      {showReleaseRescueButton(rescue, rescuer) && (
        <Button
          fullWidth
          startIcon={<CloseIcon />}
          size="large"
          color="primary"
          variant={buttonVariant}
          onClick={handleReleaseClick}
        >
          {formatMessage({ id: 'rescuer-dashboard-mobile.buttons.release-rescue' })}
        </Button>
      )}
    </>
  );
};

export default ReleaseRescueButtons;
